import { render } from "./teacherabout.vue?vue&type=template&id=3d68716e"
import script from "./teacherabout.vue?vue&type=script&lang=js"
export * from "./teacherabout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__